import React, { createContext, useEffect, useState } from "react";
// import { useStaticQuery, graphql } from "gatsby"
import Header from "./Header";
import Footer from "./Footer";
import Cursor from "./ui/Cursor";

const WrapperContext = createContext();

// const query = graphql`
//   query {
//     siteBuildMetadata {
//       buildTime
//     }
//   }
// `

const Layout = ({ children, location, pageContext: { template, isHome } }) => {
  // const { siteBuildMetadata } = useStaticQuery(query)
  const settings = {
    test: "test",
  };
  const [isMobile, setIsMobile] = useState(undefined);

  useEffect(() => {
    _format();
    window.addEventListener("resize", _format);
    window.addEventListener("scroll", _format);

    return () => {
      window.removeEventListener("resize", _format);
      window.removeEventListener("scroll", _format);
    };
  }, []);

  const _format = () => {
    // console.log(template);
    if (template === "landing") return;

    if (window.innerWidth < 982 && "ontouchstart" in window) setIsMobile(true);

    document.documentElement.style.setProperty(
      "--appHeight",
      window.innerHeight + "px"
    );

    const headerBounding = document
      .querySelector("header#site-header")
      .getBoundingClientRect();
    const headerHeight = headerBounding.height > 0 ? headerBounding.height : 58;
    document.documentElement.style.setProperty(
      "--headerHeight",
      headerHeight + "px"
    );

    document.documentElement.style.setProperty(
      "--headerHeightMobile",
      68 + "px"
    );

    document.documentElement.style.setProperty(
      "--appInnerHeight",
      window.innerHeight - headerHeight * 2 + "px"
    );
  };

  return (
    <WrapperContext.Provider
      value={{ template, settings, location, isHome, isMobile }}>
      <div id='page'>
        {template !== "landing" && <Header />}
        <main>{children}</main>
        {template !== "landing" && <Footer />}
      </div>
      {/* <Cursor /> */}
    </WrapperContext.Provider>
  );
};

export { WrapperContext, Layout };
